// extracted by mini-css-extract-plugin
export default {"Box_0":"FilterInputIcon-module__Box_0--_fTmo","Octicon_0":"FilterInputIcon-module__Octicon_0--I6ARH"};